import { render, staticRenderFns } from "./ProspectiveHistoryTable.vue?vue&type=template&id=144f9aae&"
import script from "./ProspectiveHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ProspectiveHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports